import axios from 'axios';

const API_URL = '/api/surgery';

export const getSurgeries = async (userId) => {
    try {
        const response = await axios.get(`${API_URL}/${userId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching surgeries:", error);
        throw error;
    }
};

export const createSurgery = async (surgeryData) => {
    try {
        const response = await axios.post(API_URL, surgeryData);
        return response.data;
    } catch (error) {
        console.error("Error creating surgery:", error);
        throw error;
    }
};

export const updateSurgery = async (id, surgeryData) => {
    try {
        const response = await axios.put(`${API_URL}/${id}`, surgeryData);
        return response.data;
    } catch (error) {
        console.error("Error updating surgery:", error);
        throw error;
    }
};

export const deleteSurgery = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting surgery:", error);
        throw error;
    }
};